import {
  ArrowRightOutlined, CheckCircleOutlined, CloudServerOutlined,
} from '@ant-design/icons';
import {
  Alert, Button, Flex, Space, Tag, Typography,
} from 'antd';
import React from 'react';
import { Link } from 'react-router-dom';
import { truncate } from 'lodash-es';
import { useMediaQuery } from 'usehooks-ts';
import useIsDesktop from '/src/hooks/useIsDesktop';
import UploadProvider from '/src/components/UploadProvider';
import Router from '/src/constants/router';
import VPNWarn from './VPNWarn';
import { useMobileNavTitle } from '/src/components/MobileTopNav';

function Header({ video, actions, ...props }) {
  const isDesktop = useIsDesktop();
  const isMobile = useMediaQuery('(max-width: 768px)');
  useMobileNavTitle(video?.title || video?.filename);
  const routes = [
    {
      path: '/',
      title: 'داشبورد',
    },
    {
      path: '/videos',
      title: 'ویدیوها',
    },
    {
      title: video?.title || video?.filename || video?.id,
    },
  ];

  function renderError() {
    if (video.state === 'NOT_PUBLISHED' && video?.errorMessage?.includes('quota')) {
      return (
        <Alert
          showIcon
          closable
          className="mb-4"
          title="محدودیت آپلود"
          description={(
            <div>
              به علت ظرفیت محدود و ترافیک بالا ویدیو شما در صف انتشار قرار گرفت و در ساعات آتی منتشر خواهد شد
              ، تیم پشتیبانی در تلاش است با افزایش منابع این تاخیر را به حداقل برساند

            </div>
          )}
          type="warning"
        />
      );
    }

    return null;
  }
  return (

    <>
      {renderError()}

      <div {...props} className={`${props.className || ''} w-full`}>
        <Flex justify="space-between" align="center" gap="small" className="mb-3">
          {/* On mobile the fixed top navbar provides the back button; keep a
              spacer so actions stay on their side */}
          {!isMobile ? (
            <Button
              type="text"
              icon={<ArrowRightOutlined />}
              iconPlacement="start"
              onClick={() => Router.navigate('/videos')}
              className="text-gray-600"
            >
              ویدیوها
            </Button>
          ) : (
            <span />
          )}
          {actions}
        </Flex>
        <Flex justify="space-between" align="center" gap="small" wrap>
          {/* <Space style={{ maxWidth: '100%' }} split=" / ">
            {
              routes.map((r) => (
                r.path ? <Link to={r.path} key={r.title}>{r.title}</Link> : (
                  <Typography.Text ellipsis key={r.title}>
                    {truncate(r.title, { length: isDesktop ? 30 : 20 })}
                  </Typography.Text>
                )
              ))
            }
          </Space> */}
          {
            video.fileState === 'UPLOAD_FAILED' && (
              <Tag bordered={false} icon={<CheckCircleOutlined />} color="#d0234a">
                خطا در آپلود
              </Tag>
            )
          }
        </Flex>
      </div>
      {
        video.state === 'PUBLISHING' && (
          <Alert
            showIcon
            closable
            className="mb-2"
            description="ویدیو در حال انتشار است..."
            type="info"
          />
        )
      }
      {
        video.fileState === 'UPLOADED' && video.state === 'WAITING_FOR_PUBLISH' && (
          <Alert
            showIcon
            closable
            className="mb-2"
            description="آپلود تکمیل شده و در صف انتشار قرار گرفته است"
            type="info"
            icon={<CloudServerOutlined />}
          />
        )
      }
      {
        video.state === 'EXPIRED' && (
          <Alert
            showIcon
            closable
            className="mb-2"
            description="این آپلود منقضی شده و امکان ادامه آپلود وجود ندارد"
            type="error"
          />
        )
      }
      <VPNWarn />
      <UploadProvider.UploadStatus />
    </>

  );
}
export default Header;
